export default __webpack_public_path__ + "static/favicon-6dac5769bd013ccec5f45251de666435.png";